var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8565 1.375V2.2C13.9523 2.83723 16.2848 5.61172 16.2848 8.9375V9.74531C16.2848 11.7691 17.0185 13.7156 18.3416 15.2281L18.6554 15.5848C19.0117 15.993 19.1007 16.5688 18.8802 17.0629C18.6597 17.557 18.1762 17.875 17.6419 17.875H1.35706C0.822712 17.875 0.338027 17.557 0.119115 17.0629C-0.099797 16.5688 -0.0122365 15.993 0.342819 15.5848L0.65732 15.2281C1.98216 13.7156 2.71413 11.7691 2.71413 9.74531V8.9375C2.71413 5.61172 5.00842 2.83723 8.1424 2.2V1.375C8.1424 0.615742 8.74884 0 9.49946 0C10.2501 0 10.8565 0.615742 10.8565 1.375ZM9.49946 22C8.77852 22 8.08727 21.7121 7.57837 21.1965C7.06946 20.6809 6.78533 19.9418 6.78533 19.25H12.2136C12.2136 19.9418 11.9295 20.6809 11.4206 21.1965C10.9117 21.7121 10.1822 22 9.49946 22Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.4e356f375d075a2135c338b8910990a8.svg";
export { ForwardRef as ReactComponent };